import { Observable } from 'rxjs/Observable';


export const PROFESSEUR_OPEN_SHOW = 'PROFESSEUR_OPEN_SHOW';
export const PROFESSEUR_OPEN_EDIT = 'PROFESSEUR_OPEN_EDIT';
export const PROFESSEUR_OPEN_SHOW_SUCCESS = 'PROFESSEUR_OPEN_SHOW_SUCCESS';
export const PROFESSEUR_OPEN_EDIT_SUCCESS = 'PROFESSEUR_OPEN_EDIT_SUCCESS';

export const PROFESSEUR_CLEAR = 'PROFESSEUR_CLEAR';
export const PROFESSEUR_CLEAR_SEARCH = 'PROFESSEUR_CLEAR_SEARCH';
export const PROFESSEUR_SEARCH = 'PROFESSEUR_SEARCH';
export const PROFESSEUR_UPDATE = 'PROFESSEUR_UPDATE';
export const PROFESSEUR_CREATE = 'PROFESSEUR_CREATE';
export const PROFESSEUR_DELETE = 'PROFESSEUR_DELETE';

export const PROFESSEUR_SEARCH_SUCCESS = 'PROFESSEUR_SEARCH_SUCCESS';
export const PROFESSEUR_UPDATE_SUCCESS = 'PROFESSEUR_UPDATE_SUCCESS';
export const PROFESSEUR_CREATE_SUCCESS = 'PROFESSEUR_CREATE_SUCCESS';
export const PROFESSEUR_DELETE_SUCCESS = 'PROFESSEUR_DELETE_SUCCESS';

export const PROFESSEUR_ERROR = 'PROFESSEUR_ERROR';

export const ProfesseurActions = {

    clear: ({id, errorCallback}) => {
        return {
            type: PROFESSEUR_CLEAR,
            payload: {id, errorCallback},
        };
    },

    clearSearch: ({errorCallback}) => {
        return {
            type: PROFESSEUR_CLEAR_SEARCH,
            payload: {errorCallback},
        };
    },

    search: ({http, model, form, params, errorCallback}) => {
        return {
            type: PROFESSEUR_SEARCH,
            payload: {http, model, form, params, errorCallback}
        };
    },

    create: ({http, model, form, params, successCallback, errorCallback}) => {
        return {
            type: PROFESSEUR_CREATE,
            payload: {http, model, form, params, successCallback, errorCallback}
        };
    },

    update: ({http, model, form, params, successCallback, errorCallback}) => {
        return {
            type: PROFESSEUR_UPDATE,
            payload: {http, model, form, params, successCallback, errorCallback}
        };
    },

    delete: ({http, model, params, successCallback, errorCallback}) => {
        return {
            type: PROFESSEUR_DELETE,
            payload: {http, model, params, successCallback, errorCallback}
        };
    },

    openEdit: ({http, professeur, disponibilite, params, errorCallback}) => {
        return {
            type: PROFESSEUR_OPEN_EDIT,
            payload: {http, professeur, disponibilite, params, errorCallback}
        };
    },

    openShow: ({http, professeur, disponibilite, cours, params: {basicParams, coursParams}, errorCallback}) => {
        return {
            type: PROFESSEUR_OPEN_SHOW,
            payload: {http, professeur, disponibilite, cours, params: {basicParams, coursParams}, errorCallback}
        };
    }

};

export const ProfesseurEpics = [

    // OPEN EDIT PROFESSEUR
    ($action, store) => {
        return $action.ofType(PROFESSEUR_OPEN_EDIT).mergeMap(action => {
            const {http, professeur, disponibilite, params, errorCallback} = action.payload;

            return Observable.forkJoin(
                professeur.getResource('default', 'get').call(http, 'findById', params),
                disponibilite.getResource('professeur', 'get').call(http, 'findByProfesseurId', params)
            ).map((data) => {
                const [prof, dispos] = data;
                (<any>prof).disponibilites = dispos;

                return {
                    type: PROFESSEUR_OPEN_EDIT_SUCCESS,
                    payload: prof,
                };
            })
            .catch((error) => {
                errorCallback(error);
                return Observable.of({
                    type: PROFESSEUR_ERROR,
                    error
                });
            });
        });
    },

    // OPEN SHOW PROFESSEUR
    ($action, store) => {
        return $action.ofType(PROFESSEUR_OPEN_SHOW).mergeMap(action => {
            const {http, professeur, disponibilite, cours, params: {basicParams, coursParams}, errorCallback} = action.payload;

            return Observable.forkJoin(
                professeur.getResource('default', 'get').call(http, 'findById', basicParams),
                disponibilite.getResource('professeur', 'get').call(http, 'findByProfesseurId', basicParams),
                cours.getResource('default', 'get').call(http, 'findByProfesseurIdAndDates', coursParams),
            ).map(data => {

                const [prof, dispos, cours] = data;
                (<any>prof).disponibilites = dispos;
                (<any>prof).cours = cours;

                return {
                    type: PROFESSEUR_OPEN_SHOW_SUCCESS,
                    payload: prof,
                };
            })
            .catch((error) => {
                errorCallback(error);
                return Observable.of({
                    type: PROFESSEUR_ERROR,
                    error
                });
            });
        });
    },

    // DELETE PROFESSEUR
    ($action, store) => {
        return $action.ofType(PROFESSEUR_DELETE).mergeMap(action => {
            const {http, model, params, successCallback, errorCallback} = action.payload;

            return model.getResource('default', 'delete')
            .call(http, params)
            .map(data => {
                if (data > 0) {
                    successCallback(data);
                    return {
                        type: PROFESSEUR_DELETE_SUCCESS,
                        payload: params[0]['id']
                    };
                } else {
                    errorCallback(data);
                    return {
                        type: PROFESSEUR_ERROR,
                        error: data
                    };
                }
            })
            .catch((error) => {
                errorCallback(error);
                return Observable.of({
                    type: PROFESSEUR_ERROR,
                    error
                });
            });
        });
    },

    // UPDATE PROFESSEUR
    ($action, store) => {
        return $action.ofType(PROFESSEUR_UPDATE).mergeMap(action => {
            const {http, model, form, params, successCallback, errorCallback} = action.payload;
console.log('UPDATE PROFESSEUR params', params);
console.log('UPDATE PROFESSEUR model http, form ', model, http, form);
            return model.getResource('default', 'update')
            .call(http, form, params)
            .map(data => {
                successCallback(data);
                return {
                    type: PROFESSEUR_UPDATE_SUCCESS,
                    payload: {id: form.value['id']}
                };
            })
            .catch((error) => {
                errorCallback(error);
                return Observable.of({
                    type: PROFESSEUR_ERROR,
                    error
                });
            });
        });
    },

    // SEARCH PROFESSEUR
    ($action, store) => {
        return $action.ofType(PROFESSEUR_SEARCH).mergeMap(action => {
            const {http, model, form, params, errorCallback} = action.payload;
            let stream = null;
            if (form.controls['id'].value) {
                stream = model.getResource('default', 'get')
                .call(http, 'findById', params);
            } else {
                stream = model.getResource('default', 'find')
                .call(http, form);
            }
            return stream.map(data => {
                if (form.controls['id'].value) {
                    return {
                        type: PROFESSEUR_SEARCH_SUCCESS,
                        payload: [data],
                    };
                } else {
                    return {
                        type: PROFESSEUR_SEARCH_SUCCESS,
                        payload: data,
                    };
                }
            })
            .catch((error) => {
                errorCallback(error);
                return Observable.of({
                    type: PROFESSEUR_ERROR,
                    error
                });
            });
        });
    },

    // CREATE PROFESSEUR
    ($action, store) => {
        return $action.ofType(PROFESSEUR_CREATE).mergeMap(action => {

            const {http, model, form, params, successCallback, errorCallback} = action.payload;

            return model.getResource('default', 'save')
            .call(http, form, params)
            .map((data) => {
                successCallback(data);
                return {
                    type: PROFESSEUR_CREATE_SUCCESS,
                    payload: {id: data, ...form.value},
                };
            })
            .catch((error) => {
                errorCallback(error);
                return Observable.of({
                    type: PROFESSEUR_ERROR,
                    error
                });
            });
        });
    },
];

const initialState = {
    loading: false,
    show: null,
    edit: null,
    list: null,
    searchForm: null,
};

export const ProfesseurReducer = (state = initialState, action: any) => {

    switch (action.type) {
        case PROFESSEUR_CLEAR:
            return {...state,
                loading: false,
                edit: {...state.edit, [action.payload.id]: null},
                show: {...state.show, [action.payload.id]: null}
            };
        case PROFESSEUR_CLEAR_SEARCH:
            return {...state,
                loading: false,
                searchForm: null,
                list: null,
            };
        case PROFESSEUR_SEARCH:
            return {...state,
                loading: true,
                searchForm: action.payload.form,
            };
        case PROFESSEUR_CREATE:
        case PROFESSEUR_DELETE:
        case PROFESSEUR_UPDATE:
        case PROFESSEUR_OPEN_SHOW:
        case PROFESSEUR_OPEN_EDIT:
            return {...state, loading: true};

        case PROFESSEUR_CREATE_SUCCESS:
            return {...state, loading: false};

        case PROFESSEUR_UPDATE_SUCCESS:
            // Reset cache so that we force reload
            return {...state,
                loading: false,
                edit: {...state.edit, [action.payload.id]: null},
                show: {...state.show, [action.payload.id]: null}
            };

        case PROFESSEUR_SEARCH_SUCCESS:
            return {...state, loading: false, list: action.payload};

        case PROFESSEUR_DELETE_SUCCESS:
            return {...state,
                loading: false,
                list: state.list ? state.list.filter(famille => famille.id !== action.payload.id) : null,
                show: {...state.show, [action.payload.id]: null},
                edit: {...state.edit, [action.payload.id]: null},
            };

        case PROFESSEUR_OPEN_SHOW_SUCCESS:
            return {...state, show: {...state.show, [action.payload.id]: action.payload}, loading: false };

        case PROFESSEUR_OPEN_EDIT_SUCCESS:
            return {...state, edit: {...state.edit, [action.payload.id]: action.payload}, loading: false };

        case PROFESSEUR_ERROR:
            return {...state, loading: false};

        default:
            return state;
    }

};



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/professeur/models/professeur.store.ts